import { ChangeEvent, FC } from 'react'
import { StyleLabel } from '../style'
import { StyleCheckbox, StyleCheckboxWrapper } from './style'
import { Field } from 'formik'

interface CheckboxProps {
  label?: string
  name: string
  onChange?: (value: any) => void
  styleLabel?: string
  styleWrapper?: string
  styleInput?: string
  value?: any
}
const Checkbox: FC<CheckboxProps> = ({
  label,
  name,
  onChange,
  styleLabel = '',
  styleWrapper = '',
  styleInput = '',
}) => {
  const handleChange = ({ form, value }) => {
    if (!!onChange) {
      onChange(value)
    } else {
      form.setFieldValue(name, value)
    }
  }

  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <StyleCheckboxWrapper styleWrapper={styleWrapper}>
            <StyleCheckbox
              checked={field.value === true}
              type="checkbox"
              styleInput={styleInput}
              onChange={() => {
                handleChange({
                  form,
                  value: !!field.value ? false : true,
                })
              }}
            />
            {!!label && (
              <StyleLabel styleLabel={styleLabel}>{label}</StyleLabel>
            )}
          </StyleCheckboxWrapper>
        )
      }}
    </Field>
  )
}

export default Checkbox
